import React, { FC } from 'react';
import {Dateable, TimePeriodable} from "../../../models/common/TimePeriodable";
import {LanguageProp} from "../../../config/LanguageConfig";
import { Nullable } from '../../../models/common/Nullable';
import {TextDisplay, TextDisplayProps} from "./TextDisplay";
import {DateTimeDisplay} from "./DateTimeDisplay";
import {VisibilityHandler} from "../VisibilityHandler";


export interface TimePeriodDisplayProps extends TimePeriodable< Nullable< Dateable >, Nullable< Dateable> >, Partial< LanguageProp >, TextDisplayProps {
    dateOnly?: boolean
    /** period is displayed on the same line. default to false */
    flex?: boolean
    timeOnly?: boolean
    /** when date null, will be displayed instead of nothing */
    ifNullComponent?: React.ReactNode
}

/**
 * Displays a date time / date / time period
 */
export function TimePeriodDisplay({
         startAt,
         finishAt,
         language,
         dateOnly,
         align,
         variant,
         textColor,
         onClick,
         className,
        flex, style,
        timeOnly,
        ifNullComponent,
    }: TimePeriodDisplayProps
) {

    return (
        <div style={{ lineHeight: '1px', ...( flex ? { display: 'flex' } : {} ) }}>
            <DateTimeDisplay
                ifNullComponent={ifNullComponent}
                variant={ variant }
                onClick={ onClick }
                textColor={ textColor }
                className={ className}
                align={ align }
                language={ language }
                dateOnly={ dateOnly }
                dateTime={ startAt }
                timeOnly={timeOnly}
                style={style}
            />
            <VisibilityHandler isVisible={ flex ?? false }>
                <TextDisplay
                    style={ { ...(style ?? {}), paddingLeft: 3+'px', paddingRight: 3+'px' } }
                    variant={ variant }
                    onClick={ onClick }
                    textColor={ textColor }
                    className={ className}
                    align={ align }
                >
                    -
                </TextDisplay>
            </VisibilityHandler>

            <DateTimeDisplay
                ifNullComponent={ifNullComponent}
                variant={ variant }
                onClick={ onClick }
                textColor={ textColor }
                className={ className}
                timeOnly={timeOnly}
                align={ align }
                language={ language }
                dateOnly={ dateOnly }
                dateTime={ finishAt }
                style={style}
            />
        </div>
    );
}